export default {
  props: {
    title: {
      default: "Título",
    },
    subTitle: {},
    idNav: {},
    skillFont: {
      default: false,
    },
  },
};
